import React from 'react';
import PropTypes from 'prop-types';

const KpiCard = ({ label, value, diff, rate, format }) => {
  const formattedValue = format === 'currency'
    ? `¥${Number(value).toLocaleString()}`
    : format === 'percent'
      ? `${value}%`
      : Number(value).toLocaleString();

  const diffClass = diff > 0
    ? 'o-kpi-card__diff--positive'
    : diff < 0
      ? 'o-kpi-card__diff--negative'
      : 'o-kpi-card__diff--neutral';

  return (
    <div className="o-kpi-card">
      <div className="o-kpi-card__label">{label}</div>
      <div className="o-kpi-card__value">{formattedValue}</div>
      {diff !== undefined && diff !== null && (
        <div className={`o-kpi-card__diff ${diffClass}`}>
          {diff > 0 ? '+' : ''}{diff}
          {rate && ` (${rate})`}
        </div>
      )}
    </div>
  );
};

KpiCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  diff: PropTypes.number,
  rate: PropTypes.string,
  format: PropTypes.oneOf(['number', 'currency', 'percent']),
};

KpiCard.defaultProps = {
  format: 'number',
};

export default KpiCard;
